import { useState } from "react";
import { handleUuid } from "../utils/utils";
import AddressInputAutoSuggest from "./AddressInputAutoSuggest";
import AlertComponent from "./AlertComponent";
import HistoryMapInfo from "./HistoryMapInfo";
import { useStyles } from "../Styles/styles";
import { ChevronRight } from "@material-ui/icons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const AddressWithAlertAndHmi = ({
  address,
  showHmi = true,
  showAlert = true,
  showPeople = false,
  addressInputLabel,
  setAddress,
  validAlertName,
  alertType,
  deleteAlert,
  addAlert,
  userRoles,
  incidentId = null,
  onFocus,
  onBlur,
  containerStyle = {},
  showIntersection = false,
  inputStyles = {},
  disabled,
  handleIncidentOpening = null,
  handlePersonOpening = null,
  incidentPeople = null,
  ...props
}) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div id={handleUuid()} className={classes.flexRow} style={containerStyle}>
        {address?.intersection && showIntersection && (
          <button
            type="button"
            data-testid="intersection-toggle"
            aria-label={open ? "Collapse intersection" : "Expand intersection"}
            aria-expanded={open}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              background: "none",
              color: "inherit",
              border: 0,
              padding: 0,
            }}
            onClick={() => setOpen(prevState => !prevState)}
          >
            {open ? <KeyboardArrowDownIcon /> : <ChevronRight />}
          </button>
        )}
        <AddressInputAutoSuggest
          userRoles={userRoles}
          address={address}
          id={handleUuid()}
          setAddress={setAddress}
          title={addressInputLabel}
          textfieldClass={classes.smallMatchMargin}
          pauseLocationPolling={onFocus}
          resumeLocationPolling={onBlur}
          customClass={inputStyles}
          disabled={disabled}
          {...props}
        />
        {showHmi && (
          <HistoryMapInfo
            address={address}
            userRoles={userRoles}
            incidentId={incidentId}
            handleIncidentOpening={handleIncidentOpening}
            handlePersonOpening={handlePersonOpening}
            incidentPeople={incidentPeople}
            showPeople={showPeople}
            {...props}
          />
        )}
        {showAlert && (
          <AlertComponent
            parentObj={address}
            accessor={validAlertName}
            type={alertType}
            deleteHandler={deleteAlert}
            //creation throttled in parent
            updateHandler={addAlert}
            userRoles={userRoles}
            pauseLocationPolling={onFocus}
            resumeLocationPolling={onBlur}
            incidentId={incidentId}
            {...props}
          />
        )}
      </div>
      {open && showIntersection && (
        <>
          <label htmlFor="cross-street">Cross street: </label>
          <input
            style={{ border: "none", padding: 0 }}
            type="text"
            id="cross-street"
            name="name"
            value={address?.intersection}
            readOnly
          />
        </>
      )}
    </div>
  );
};

export default AddressWithAlertAndHmi;
